( function () {
	'use strict';

	/* @ngInject */
	/* eslint no-undef:0 */
	/* eslint max-params:0 */
	function EvidencesModalCtrl ( $modalInstance, group, update, observation, readOnly, isObsLevel, isTemplatePreview, TOOLTIP_MESSAGES, TITLE ) {
		var self = this;

		function activate () {
			self.allowedFileFormats = [ ];
			self.navs               = [ 'Attached', 'Available' ];
			self.active             = 0;

			if ( isObsLevel ) {
				self.navs.push( 'All' );
				self.evidenceMessage = TOOLTIP_MESSAGES.obsAttachEvidenceMsg;
			} else if ( group.hasOwnProperty( 'type' ) ) {
				self.evidenceMessage = TOOLTIP_MESSAGES.indAttachEvidenceMsg;
			} else {
				self.evidenceMessage = TOOLTIP_MESSAGES.grpAttachEvidenceMsg;
			}
		}

		function close () {
			$modalInstance.dismiss();
		}

		function reset () {
			self.isAll = true;
			self.level = {};
		}

		function setActiveTab ( value ) {
			var message = {};

			if ( isObsLevel ) {
				message = {
					'0' : function () {
						return TOOLTIP_MESSAGES.obsAttachEvidenceMsg;
					},
					'1' : function () {
						return TOOLTIP_MESSAGES.obsAvailableEvidenceMsg;
					},

					'defaultMsg' : function () {
						return;
					}
				};
			} else if ( group.hasOwnProperty( 'type' ) ) {
				message = {
					'0' : function () {
						return TOOLTIP_MESSAGES.indAttachEvidenceMsg;
					},
					'1' : function () {
						return TOOLTIP_MESSAGES.indAvailableEvidenceMsg;
					},

					'defaultMsg' : function () {
						return;
					}
				};
			} else {
				message = {
					'0' : function () {
						return TOOLTIP_MESSAGES.grpAttachEvidenceMsg;
					},
					'1' : function () {
						return TOOLTIP_MESSAGES.grpAvailableEvidenceMsg;
					},

					'defaultMsg' : function () {
						return;
					}
				};
			}

			self.evidenceMessage = ( message[ value ] || message.defaultMsg )();
		}

		activate();
		reset();

		self.evidence          = TITLE.evidence;
		self.group             = group;
		self.update            = update;
		self.observation       = observation;
		self.readOnly          = readOnly;
		self.close             = close;
		self.reset             = reset;
		self.isObsLevel        = isObsLevel;
		self.isTemplatePreview = isTemplatePreview;
		self.setActiveTab      = setActiveTab;
	}

	angular
		.module( 'app.components' )
		.controller( 'EvidencesModalCtrl', EvidencesModalCtrl );

	EvidencesModalCtrl.$inject = [ '$modalInstance', 'group', 'update', 'observation', 'readOnly', 'isObsLevel', 'isTemplatePreview', 'TOOLTIP_MESSAGES', 'TITLE' ];
} )( );
